'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { getCountdownParts } from './countdown';

/**
 * Countdown ticks in its own component so the once-a-second re-render stays
 * scoped here instead of repainting the whole page.
 */
export function DropCountdown(t0) {
  const $ = _c(27);
  const {
    onLive,
    targetMs
  } = t0;
  const [now, setNow] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setNow(Date.now());
      const timer = setInterval(() => setNow(Date.now()), 1000);
      return () => clearInterval(timer);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== now || $[3] !== targetMs) {
    t3 = now === null ? null : getCountdownParts(now, targetMs);
    $[2] = now;
    $[3] = targetMs;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const parts = t3;
  let t4;
  if ($[5] !== onLive || $[6] !== parts?.live) {
    t4 = () => {
      if (parts?.live) {
        onLive();
      }
    };
    $[5] = onLive;
    $[6] = parts?.live;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = parts?.live;
  let t6;
  if ($[8] !== onLive || $[9] !== t5) {
    t6 = [t5, onLive];
    $[8] = onLive;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  useEffect(t4, t6);
  const t7 = parts?.days;
  let t8;
  if ($[11] !== t7) {
    t8 = {
      label: "days",
      value: t7
    };
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = parts?.hours;
  let t10;
  if ($[13] !== t9) {
    t10 = {
      label: "hrs",
      value: t9
    };
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = parts?.minutes;
  let t12;
  if ($[15] !== t11) {
    t12 = {
      label: "min",
      value: t11
    };
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = parts?.seconds;
  let t14;
  if ($[17] !== t13) {
    t14 = {
      label: "sec",
      value: t13
    };
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t10 || $[20] !== t12 || $[21] !== t14 || $[22] !== t8) {
    t15 = [t8, t10, t12, t14];
    $[19] = t10;
    $[20] = t12;
    $[21] = t14;
    $[22] = t8;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  const slots = t15;
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="mb-2 font-bold text-[11px] text-white/50 uppercase tracking-[.2em]">Regular sale goes live in</div>;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== slots) {
    t17 = <div className="mt-7" role="timer" aria-label="Countdown to regular access">{t16}<div className="flex flex-wrap items-baseline gap-[clamp(16px,4vw,32px)]">{slots.map(_temp)}</div></div>;
    $[25] = slots;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  return t17;
}
function _temp(slot) {
  return <div key={slot.label} className="flex items-baseline gap-1"><span className="font-black text-[clamp(34px,9vw,54px)] text-white leading-[.9] tracking-[-.04em] tabular-nums">{slot.value ?? "\u2013\u2013"}</span><span className="font-bold text-[11px] text-white/50 uppercase tracking-[.14em]">{slot.label}</span></div>;
}